import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import { RankCtrValueGq, RankCtrValueGqProps } from '../models/RankCtrValueGq';

export function useGetCtrValuesGq(command: CommandGq) {
  const query = useCustomQuery<GQLData, GQLVariables>(gqTag, {
    variables: { command: command }, fetchPolicy: 'cache-first'
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getCtrValues?.ctrValues,
  };
}

const gqTag = gql`
  query GetCtrValues($command: GetCtrValuesCommand!) {
    projects {
      getCtrValues(command: $command) {
        ctrValues {
          ${RankCtrValueGqProps}
        }
      }
    }
  }
`;

interface GQLVariables {
  command: CommandGq;
}

export interface CommandGq {
  dummy: boolean;
}

export interface GetProjectsCommandGq extends CommandGq { }

interface GQLData {
  readonly projects: {
    readonly getCtrValues: {
      readonly ctrValues: RankCtrValueGq[];
    };
  };
}
